<template>
  <div class="welfare">
    <navigation></navigation>
    <img
      src="./images/banner.gif"
      class="welfare-bg"
    />
    <div class="welfare-content">
      <div class="welfare-banner">
        <span>即将获得福利</span>
        <div
          class="welfare-card"
          v-if="myAchievements.length===0"
        ><img src="./images/icon_fudai@2x.png" /><span>福袋里空空如也，快去参与活动赚取奖励吧！</span></div>
        <div class="welfare-img">
          <img
            :src="item.bannerImgUrl"
            @click="jumpTo(item.actionUrl)"
            v-for='(item,index) in myAchievements'
            :key="index"
          />
        </div>
      </div>
      <div class="welfare-benefits">
        <div class="welfare-benefits-title">
          <span>我的成就</span>
          <span @click="findQuan">查看我的券包</span>
        </div>
        <div
          class="benefits"
          v-for="(allItem,index) in allTitle"
          :key="index"
        >
          <img
            class="benefits-mergeShape"
            src="./images/mergeShape.png"
            v-if="['new', 'newV2'].includes(allItem.status)"
          />
          <img
            class="benefits-mergeShape"
            src="./images/mergeShape1.png"
            v-else-if="allItem.status==='advanced'"
          />
          <div
            class="benefits-mergeShape"
            v-else
          />
          <div class="benefits-img">
            <div
              v-if='allItem.benefitsStep<allItem.title.length'
              :class="['benefits-noCompletion', {'newbie-act': ['new', 'newV2'].includes(allItem.status)}]"
            >
              <div
                v-for="(item,index) in allItem.couponTypeList"
                :key="index"
              >
                <img
                  :src="`${item.couponType==='AMOUNT'?require('./images/icon_xianjin@2x.png'):require('./images/icon_mianxi@2x.png')}`"
                  @click="couponJump(allItem.actionUrl,allItem.couponStatus)"
                >
              </div>
            </div>
            <img
              v-else
              src="./images/icon_wancheng@2x.png"
              class="benefits-completion"
            >
          </div>
          <div class="benefits-line">
            <ul>
              <li
                v-for="item in allItem.title"
                :key="item.key"
              >
                <img
                  v-if='allItem.benefitsStep>item.key'
                  src="../images/icon_gou1@2x.png"
                >
                <img
                  v-else
                  src="../images/icon_gou2@2x.png"
                >
              </li>
              <div
                class="progress"
                :class="`progress${allItem.benefitsStep}`"
              />
            </ul>
          </div>
          <div class="benefits-title">
            <div
              v-if="allItem.benefitsStep>=allItem.title.length"
              class="benefits-title-center"
            ><span>{{index|overTitle}}</span></div>
            <ul v-else>
              <li
                v-for="(item) in allItem.title"
                :key="item.key"
                :class="changeClass(item,allItem)"
                @click="navigateTo(nextNode(allItem),allItem,item.key===allItem.benefitsStep)"
              >{{item.value}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="about-title">关注我们</div>
      <div class="about">
        <img
          src="../images/img_erweima@2x.png"
          alt="ct_tmd"
          id="qrcode"
          class="qrcode"
          ref="savePop"
        >
        <div class="column">
          <div class="top">关注公众号：获取更多精彩福利</div>
          <div class="center">1、长按二维码保存至相册</div>
          <div class="bottom">
            <div class="left">2、微信搜索：ct_tmd</div>
            <div
              class="right"
              @click="copy"
            >复制</div>
          </div>
        </div>
      </div>
      <div class="footer">
        活动最终解释权归天美贷所有
      </div>
    </div>
    <van-popup
      v-model="protocolPopup"
      class="protocol-popup"
      position="bottom"
    >
      <dl>
        <dt @click="savePhoto">
          保存图片至相册
        </dt>

        <dt @click="closePop">
          取消
        </dt>
      </dl>
    </van-popup>
  </div>
</template>
<script>
import { judgeClientSystem, copyToClipbord } from '../../../assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { mapActions } from 'vuex'
import { Popup, Toast } from 'vant'
export default {
  name: 'new-welfare-index',
  customReadyNotify: true,
  data () {
    return {
      myAchievements: [], // 我的成就
      allTitle: [], // 所有数据
      protocolPopup: false
    }
  },
  components: {
    Popup,
    Toast
  },
  async created () {
    try {
      await Promise.all([this.getBenefits(), this.queryAchievement()])
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },
  mounted () {
    this.$refs['savePop'].addEventListener('touchstart', this.start)
    this.$refs['savePop'].addEventListener('touchend', this.savePop)
  },
  filters: {
    overTitle (index) {
      if (index === 0) {
        return '新手任务完成'
      } else {
        return '进阶任务完成'
      }
    }
  },
  methods: {
    ...mapActions('user', ['getBenefitsX', 'queryAchievementX']),
    couponJump (url, status) {
      if (!['SUC_USE', 'OVERDUE'].includes(status)) {
        this.jumpTo(url)
      }
    },
    changeClass (item, allItem) {
      let value = ''
      if (item.key === allItem.benefitsStep) {
        value = 'benefits-selected'
      } else {
        if (item.key < allItem.benefitsStep) {
          value = 'benefits-front'
        } else {
          value = ''
        }
      }
      if (['new', 'newV2'].includes(allItem.status) && item.key === 2) {
        value = `${value} left450`
      }
      return value
    },
    nextNode (item) {
      const { nextStep = '', relationId, type, couponTypeList } = item
      if (['OCR', 'INFO', 'CREDIT', 'CREDIT_REVIEW', 'CREDIT_LOCKED', 'CREDIT_SUCCESS', 'FIRST_LOAN', 'LOAN_AUDIT', 'LOAN_LOCKED', 'LOCKED', 'LOANING', 'LOAN_REVIEW', 'LOAN_WAIT_VIP', 'LOAN'].includes(nextStep)) {
        return this.$router.push('/middle/limit')
      } else {
        switch (nextStep) {
          case 'UN_USE_COUPON':
            let id = null
            if (couponTypeList && couponTypeList.length) {
              id = couponTypeList[0].couponRecordId
            }
            return { h5: `/quan/detail?couponRecordId=${id}` }
          case 'LOAN_PASSED':
          case 'REPAY':
            return { h5: '/repayment', native: 'repayment' }
          case 'REPAYING':
            return { h5: `/repayment/result?repayId=${relationId}&type=${type}` }
          default:
            return { h5: '/middle/limit' }
        }
      }
    },
    // 查看我的券包
    findQuan () {
      this.$report({ id: 10189 })
      console.log()
      if (this.allTitle[0] && ['SUC_USE', 'OVERDUE'].includes(this.allTitle[0].couponStatus)) {
        this.$router.push('/quan/history')
      } else {
        this.$router.push('/quan/list')
      }
    },
    // 跳转到新界面
    jumpTo (url) {
      this.$report({ id: 10188 })
      window.location.href = url
    },
    start () {
      this.time = new Date().getTime()
    },
    savePop () {
      let time = new Date().getTime()
      if (time - this.time > 1000) {
        this.$report({
          id: 10156
        })
        this.protocolPopup = true
      }
    },
    closePop () {
      this.protocolPopup = false
    },
    savePhoto () {
      this.$report({
        id: 10157
      })
      this.downloadIamge(
        'http://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/authenticate/1_15683410918_Web_1605512702096',
        'qrcode'
      )
      this.protocolPopup = false
    },

    saveSuccess () {
      this.$report({
        id: 10159
      })
      Toast({
        message: '已保存至系统相册',
        icon:
          'http://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/authenticate/1_15683410918_Web_1605509117666',
        duration: 1500
      })
    },

    async downloadIamge (imgsrc, name) {
      if (hasNativeMethod('saveQRCode')) {
        const res = await jsBridge('saveQRCode', {
          url: imgsrc,
          name: name
        })
        if (res && res.code === 'OK') {
          this.saveSuccess()
        }
      } else {
        let image = new Image()
        let self = this
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function () {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
          let a = document.createElement('a') // 生成一个a元素
          let event = new MouseEvent('click') // 创建一个单击事件
          a.download = name // 设置图片名称没有设置则为默认
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
          self.saveSuccess()
        }
        image.src = imgsrc
      }
    },
    copy () {
      this.$report({
        id: 10158
      })
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    },
    async queryAchievement () {
      let response = await this.queryAchievementX()
      if (response.success) {
        this.myAchievements = response.data || []
      } else {
        this.$message(response.msg)
      }
    },
    // 获取福利数据
    async getBenefits () {
      let response = await this.getBenefitsX()
      if (response.success) {
        const {
          data: { advancedReach, newPersonReach, newPersonReachV2 }
        } = response || {}
        let arr = [newPersonReach, newPersonReachV2, advancedReach]
        arr.map((item, index) => {
          const {
            achievementStep,
            nextStep,
            relationId,
            type,
            couponTypeList = [],
            couponRecordId,
            couponStatus,
            actionUrl
          } = item || {}
          if (index === 0 && item) {
            let {
              key,
              arr = [
                { key: 0, value: '实名认证' },
                { key: 1, value: '通过授信' },
                { key: 2, value: '首笔提现' }
              ]
            } = this.dealValue(nextStep) || {}
            this.allTitle.push({
              benefitsStep: key,
              title: arr,
              relationId,
              couponTypeList,
              couponRecordId,              
              nextStep,
              actionUrl,
              status: 'new',
              type
            })
          } else if (index === 1 && item) {
            let {
              key,
              arr = [
                { key: 0, value: '申请授信' },
                { key: 1, value: '首笔借款' },
                { key: 2, value: '提现红包' }
              ]
            } = this.dealNewbieActivityValue(nextStep) || {}
            this.allTitle.push({
              benefitsStep: key,
              title: arr,
              relationId,
              couponTypeList,
              couponRecordId,
              nextStep,
              actionUrl,
              couponStatus,
              status: 'newV2',
              type
            })
          } else if (item) {
            let {
              key,
              arr = [
                { key: 0, value: '借款+1笔' },
                { key: 1, value: '借款+2笔' },
                { key: 2, value: '按时还款+3笔' }
              ]
            } = this.dealAdvancedValue(achievementStep) || {}
            this.allTitle.unshift({
              benefitsStep: key,
              title: arr,
              relationId,
              couponTypeList,
              couponRecordId,
              nextStep,
              actionUrl,
              status: 'advanced',
              type
            })
          }
        })
      } else {
        this.$message(response.msg)
      }
    },
    // 处理返回的数据为步骤
    dealValue (data) {
      if ('OCR'.includes(data)) {
        return { key: 0 }
      } else if ('CREDIT,CREDIT_REVIEW,CREDIT_LOCKED'.includes(data)) {
        return {
          key: 1,
          arr: [
            { key: 0, value: '完成实名' },
            { key: 1, value: '去授信' },
            { key: 2, value: '首笔提现' }
          ]
        }
      } else if ('LOAN,LOANING,LOAN_LOCKED'.includes(data)) {
        return {
          key: 2,
          arr: [
            { key: 0, value: '完成实名' },
            { key: 1, value: '通过授信' },
            { key: 2, value: '去提现' }
          ]
        }
      } else if (['LOAN_PASSED'].includes(data)) {
        return { key: 3 }
      } else {
        return { key: 0 }
      }
    },
    // 处理新人活动数据
    dealNewbieActivityValue (data) {
      /**
       * 下一阶段名称 CREDIT_APPLY 授信申请、FIRST_LOAN 首笔借款 USE_COUPON 提现红包
      */
      const stepObj = {
        'CREDIT_APPLY': 0,
        'FIRST_LOAN': 1,
        'LOANING': 1,
        'LOAN_LOCKED': 1,
        'UN_USE_COUPON': 2,
        'USE_COUPON': 3
      }
      return { key: stepObj[data] || 0 }
    },
    // 处理返回的数据为步骤
    dealAdvancedValue (data) {
      if ('LOAN_PASS_NUM_1'.includes(data)) {
        return { key: 1 }
      } else if ('LOAN_PASS_NUM_2'.includes(data)) {
        return { key: 2 }
      } else if ('REPAY_SUCCESS_COUNT_3'.includes(data)) {
        return { key: 3 }
      } else {
        return { key: 0 }
      }
    },
    // 埋点
    buriedPoint (id, visible = 1) {
      this.$report({
        id,
        args: {
          screen: 'page_withdrawmiddle',
          visible
        }
      })
    },
    // 埋点
    report (allItem) {
      let id = null
      const { status, nextStep, achievementStep } = allItem
      if (status === 'new') {
        let { key } = this.dealValue(nextStep)
        if (key === 0) {
          id = 10190
        } else if (key === 0) {
          id = 10191
        } else {
          id = 10192
        }
      } else {
        let { key } = this.dealAdvancedValue(achievementStep)
        if (key === 0) {
          id = 10193
        } else if (key === 0) {
          id = 10194
        } else {
          id = 10195
        }
      }
      this.$report({ id })
    },
    judge (nextStep, path) {
      if (
        hasNativeMethod('navigateTo') &&
        !!path.native &&
        judgeClientSystem() !== 'IOS'
      ) {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true })
      } else {
        this.$router.push(path.h5)
      }
    },
    navigateTo (path, allItem, bool) {
      if (!['SUC_USE', 'OVERDUE'].includes(allItem.couponStatus)) {
        if (bool) {
          this.report(allItem)
          this.buriedPoint(100000, 1)
          this.judge(allItem.nextStep, path)
        } 
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.welfare {
  min-height: 100%;
  .protocol-popup {
    background-color: transparent;
    dl {
      background-color: #fff;
      border-radius: 30px 30px 0px 0px;
      padding-bottom: 80px;
      dt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        justify-content: space-around;
        padding: 0 50px;
        height: 110px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
      }
      dd {
        height: 110px;
        padding: 0 40px;
        line-height: 110px;
        font-size: 30px;
        border-top: 1px solid #eeeeee;
      }
    }
  }

  background: #fafafa;
  &-bg {
    width: 750px;
    height: 340px;
    position: relative;
  }
  &-content {
    position: relative;
    width: 750px;
    background: #fafafa;
    padding: 82px 40px 46px;
    margin-top: -60px;
    border-radius: 30px 30px 0px 0px;
    .welfare-banner {
      span {
        display: inline-block;
        height: 53px;
        font-size: 38px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 53px;
        margin-bottom: 22px;
      }
    }
    .welfare-card {
      width: 670px;
      height: 240px;
      padding: 50px 0 37px;
      text-align: center;
      background: #ffffff;
      box-shadow: 0px 20px 20px 0px rgba(231, 231, 231, 0.5);
      border-radius: 20px;
      // margin-bottom:30px;
      img {
        display: block;
        margin: auto;
        width: 90px;
        height: 90px;
        margin-bottom: 35px;
      }
      span {
        height: 30px;
        text-align: center;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 30px;
      }
    }
    .welfare-img {
      img {
        display: block;
        margin: auto;
        width: 670px;
        height: 180px;
        margin-top: 30px;
      }
      img:nth-child(1) {
        margin-top: 0px;
      }
    }
    .welfare-benefits {
      margin-top: 82px;
      &-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 22px;
        span:nth-child(1) {
          height: 53px;
          font-size: 38px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 53px;
        }
        span:nth-child(2) {
          height: 37px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 37px;
          position: relative;
          right: 40px;
        }
        span:nth-child(2)::after {
          content: ">";
          color: rgb(204, 206, 214);
          width: 10px;
          height: 17px;
          position: absolute;
          right: -20px;
          top: -2px;
        }
      }
      .benefits {
        position: relative;
        width: 670px;
        padding-bottom: 28px;
        margin-bottom: 24px;
        background-color: #fff;
        border-radius: 20px;
        background: #ffffff;
        background-size: 100% 100%;
        overflow: hidden;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        &-mergeShape {
          width: 170px;
          height: 46px;
          line-height: 46px;
        }
        &-img {
          margin: -18px auto 0;
          text-align: center;
          .benefits-noCompletion {
            width: 310px;
            min-height: 18px;
            display: flex;
            justify-content: space-between;
            margin: auto;
            // 新人活动，单独处理
            &.newbie-act {
              justify-content: space-around;
            }
            img {
              width: 65px;
              height: 67px;
              margin-left: 25px;
            }
          }
          .benefits-completion {
            margin-left: 40px;
            width: 158px;
            height: 72px;
          }
        }
        &-selected {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff4633;
          line-height: 44px;
        }
        &-front {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff4633;
          line-height: 44px;
        }
        &-line {
          margin: 15px 0 0 106px;
          width: 440px;
          height: 8px;
          line-height: 8px;
          background: #ffcbbc;
          border-radius: 12px;
          position: relative;
          ul {
            position: absolute;
            display: flex;
            top: -8px;
            li {
              position: relative;
              margin-right: 216px;
              img {
                left: 0;
                position: absolute;
                z-index: 2;
                width: 24px;
                height: 24px;
                background-size: 100%;
              }
            }
            li:nth-child(2) {
              left: -2px;
            }
            .progress {
              position: absolute;
              z-index: 1;
              top: 8px;
              left: 20px;
              width: 0px;
              height: 8px;
              background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
              border-radius: 12px;
            }
            .progress0 {
              width: 0px;
            }
            .progress1 {
              width: 110px;
            }
            .progress2 {
              width: 325px;
            }
            .progress3 {
              width: 420px;
            }
          }
        }
        &-title {
          margin: 25px 0 0 10px;
          &-center {
            margin-top: 33px;
            padding-left: 260px;
            span {
              height: 30px;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ff4633;
              line-height: 30px;
            }
          }
          ul {
            display: flex;
            position: relative;
            height: 40px;
            line-height: 40px;
            li {
              position: absolute;
              left: 34px;
              background: #ffffff;
              border-radius: 20px;
              text-align: center;
              padding: 0 29px;
            }
            .left450 {
              left: 472px !important;
            }
            li:nth-child(2) {
              left: 248px;
            }
            li:nth-child(3) {
              left: 444px;
            }
          }
        }
        &-selected {
          border: 1px solid #ff4633;
          background: #ffffff;
          border-radius: 22px;
          line-height: 40px;
        }
        &-find-img {
          background-size: 100%;
          position: absolute;
          right: 14px;
          top: 18px;
          width: 7px;
          height: 12px;
          line-height: 12px;
          overflow: hidden;
        }
      }
    }
    .about-title {
      margin-top: 82px;
      height: 53px;
      font-size: 38px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 53px;
    }
    .about {
      height: 170px;
      margin-top: 18px;
      padding: 20px 0;
      background: #ffffff;
      box-shadow: 0px 20px 20px 0px rgba(231, 231, 231, 0.5);
      border-radius: 20px;
      display: flex;
      .qrcode {
        margin-left: 20px;
        width: 140px;
        height: 140px;
      }
      .column {
        margin-left: 20px;
        .top {
          margin-top: 11px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 37px;
        }
        .center {
          margin-top: 16px;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 30px;
        }
        .bottom {
          margin-top: 6px;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 30px;
          display: flex;
          .left {
            padding-right: 60px;
          }
          .right {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9fc0d2;
            line-height: 30px;
          }
        }
      }
    }
  }

  .footer {
    text-align: center;
    padding: 52px 0 36px 0;
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #cccccc;
    line-height: 30px;
  }
}
</style>